export default customElements.define('w-link-list', class LinkList extends wealthify.CustomElementBaseClass {
    
    constructor() {
        const styleSelector = 'c-link-list';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `
            <w-card size="micro" data-root>
            </w-card>`,
            cacheDom: [],
        };

        super(config);
    }

    static get requiredItemsProperties() {
        return [
            'icon',
            'label',
            'subLabel',
            'url'
        ];
    }

    static get observedProps() {
        return [
            new wealthify.Prop('items', {
                type: wealthify.propTypes.Array(),
                validators: [wealthify.propValidators.ArrayObjectContainsKeys(this.requiredItemsProperties)],
            })
        ];
    }

    get propCallbacks() {
        return {items: (values) => {
            this._buildItems(values);
        }};
    }

    _buildItems(values) {
        this.dom.root.innerHTML = '';  
        
        values.forEach(item => {
            this._renderLink(item);
        });
    }

    _renderLink(item) {
        const link = this._createLink(item.url);

        const boxType = item.boxType ?? 'box-green';

        const iconGridItem = this._createIcon(item.icon,boxType);
        const actionTextGridItem = this._createActionTextContainer(item.label, item.subLabel);
        const goArrowGridItem = this._createGoArrow(item.label);

        link.appendChild(iconGridItem);
        link.appendChild(actionTextGridItem);
        link.appendChild(goArrowGridItem);

        this.dom.root.appendChild(link);
    }

    _createLink(url) {
        const link = document.createElement('a');

        link.setAttribute('href', url);
        link.setAttribute('data-slot', 'segment');
        link.classList.add(`${this.styleSelector}__link`);

        return link;
    }

    _createIcon(type, boxType) {
        const icon = document.createElement('w-icon');

        icon.usage = boxType;
        icon.type = type;
        icon.size = '150';

        return icon;
    }

    _createActionTextContainer(labelText, subLabelText) {
        const textContainer = document.createElement('div');
        const label = document.createElement('p'); // check with Scott
        const subLabel = document.createElement('p');

        label.innerHTML = labelText;
        label.classList.add(`${this.styleSelector}__label`);

        subLabel.innerHTML = subLabelText;

        textContainer.classList.add(`${this.styleSelector}__text`);
        textContainer.appendChild(label);
        textContainer.appendChild(subLabel);

        return textContainer;
    }

    _createGoArrow() {
        const goArrow = document.createElement('w-icon');
        
        goArrow.type = 'caret-forward';
        goArrow.classList.add(`${this.styleSelector}__arrow`);

        return goArrow;
    }
});